export default import.meta.ROLLDOWN_FILE_URL_DUq8YoikZLXEejpNZ1KQvg_aaf5f7cc4f43f363ede0493d